export enum RugbyUnionPenaltyKickGoalAttribute {
  Golden = 1065,
}
